import { fetchAllMembers } from 'pages/provisioning/kafka/utils/fetchMembers';
import { allowedServices } from 'utils';
import { RULE_TYPE_NAME } from './constant';

export const getPayload = (operation, order) => {
    if (operation === 'create') {
        const requestors =
            order?.ruleRows?.find((rule) => rule?.ruleType === RULE_TYPE_NAME?.TRUSTED_REQUESTOR)?.value?.map((requestor) => requestor?.gpid) || [];
        const maxOrderAmount = order?.ruleRows?.find((rule) => rule?.ruleType === RULE_TYPE_NAME?.BUDGET_AMOUNT)?.value || 0;
        const catalogServices = order?.ruleRows?.find((rule) => rule?.ruleType === RULE_TYPE_NAME?.CATALOG)?.value?.map((service) => service?.label) || [];

        return {
            name: order?.ruleName,
            criteria: {
                ...(requestors.length > 0 && { requestors }),
                ...(catalogServices.length > 0 && { catalogServices }),
                ...(maxOrderAmount && { maxOrderAmount }),
            },
            budgetCode: order?.budgetCode,
            active: true,
        };
    }
    if (operation === 'edit') {
        const payload = {
            id: order?.id,
            active: order?.active,
            name: order?.ruleName,
            criteria: {},
            budgetCode: order?.budgetCode,
        };

        const ruleHandlers = {
            'Trusted Requestor': (rule) => {
                const requestors = rule?.value?.map((requestor) => requestor?.gpid);
                if (requestors?.length > 0) {
                    payload.criteria = {
                        ...payload.criteria,
                        requestors,
                    };
                }
            },
            'Max Order Amount': (rule) => {
                if (rule?.value) {
                    payload.criteria = {
                        ...payload.criteria,
                        maxOrderAmount: rule?.value,
                    };
                }
            },
            Catalog: (rule) => {
                const catalogServices = rule?.value?.map((service) => service?.label);
                if (catalogServices?.length > 0) {
                    payload.criteria = {
                        ...payload.criteria,
                        catalogServices,
                    };
                }
            },
        };
        order?.ruleRows?.forEach((rule) => {
            const handler = ruleHandlers[rule?.ruleType];
            if (handler) {
                handler(rule);
            }
        });
        return payload;
    }
    return {};
};

export const formOrderObj = async (rule, cmpCatalogs, cmpRiCatalogs) => {
    let members = [];
    let catalogServices = [];
    // Ensure requestors is always an array
    const requestors = Array.isArray(rule?.criteria?.requestors) ? rule?.criteria?.requestors : [rule?.criteria?.requestors]?.filter(Boolean);

    if (requestors.length) {
        members = (await fetchAllMembers(requestors)) || [];
    }
    if (rule?.criteria?.catalogServices && rule?.criteria?.catalogServices?.length) {
        const allCatalogs = await [
            ...cmpCatalogs?.filter((item) => allowedServices(item?.catalogDefinitionId)),
            ...cmpRiCatalogs?.filter((item) => allowedServices(item?.['reference-implementation-id'])),
        ];
        catalogServices =
            (await allCatalogs
                ?.filter((item) => rule?.criteria?.catalogServices?.includes(item?.catalogDefinitionId || item?.['reference-implementation-id']))
                ?.map((app) => ({
                    value: app?.displayName || app?.name,
                    label: app?.catalogDefinitionId ? app?.catalogDefinitionId : app?.['reference-implementation-id'],
                }))) || [];
    }
    return {
        id: rule?.id,
        active: rule?.active,
        budgetCode: rule?.budgetCode,
        ruleName: rule?.name,
        ruleRows: [
            ...(Array.isArray(members) && members.length > 0
                ? [
                      {
                          ruleType: RULE_TYPE_NAME?.TRUSTED_REQUESTOR,
                          value: members,
                      },
                  ]
                : []),
            ...(rule?.criteria?.maxOrderAmount
                ? [
                      {
                          ruleType: RULE_TYPE_NAME?.BUDGET_AMOUNT,
                          value: rule?.criteria?.maxOrderAmount,
                      },
                  ]
                : []),
            ...(Array.isArray(catalogServices) && catalogServices.length > 0
                ? [
                      {
                          ruleType: RULE_TYPE_NAME?.CATALOG,
                          value: catalogServices,
                      },
                  ]
                : []),
        ],
    };
};

export const handleReset = () => {
    return {
        id: '',
        active: false,
        budgetCode: '',
        ruleName: '',
        ruleRows: [
            {
                ruleType: null,
                value: null,
            },
        ],
        delegateId: null,
        delegateOwner: null,
        delegateOwnerDetails: null,
        startDate: null,
        endDate: null,
    };
};

export default {};
